import { useMemo } from 'react';
import useCategories from '../../core/queries/useCategories';
import useCategory from '../../core/queries/useCategory';
import addCountToTree from '../../core/util/addCountToTree';
import { buildTree } from '../../core/util/categories';
import filterCategories from '../util/filterCategories';

const useCategoryTree = ({
    categories = [],
    showEmptyCategories,
}: {
    categories: { category: { id: string }; total: number }[];
    showEmptyCategories?: boolean;
}) => {
    const { categoryId } = useCategory();
    const { categories: items, loading } = useCategories();

    const tree = useMemo(() => {
        if (!items.length) {
            return [];
        }
        return addCountToTree(
            buildTree(
                showEmptyCategories
                    ? items
                    : filterCategories(
                          items,
                          categories.map(({ category: { id } }) => id)
                      )
            ),
            categories,
            categoryId
        );
    }, [categoryId, items, categories, showEmptyCategories]);

    return {
        categoryId,
        loading,
        tree,
    };
};

export default useCategoryTree;
